module.exports = __webpack_public_path__ + "assets/img/favicon.68f2e264.png";